import { BleClient, TimeoutOptions } from "@capacitor-community/bluetooth-le";

export interface IBleClient {
    initialize(): Promise<void>;
    requestDevice(options: any): Promise<any>;
    requestLEScan(options: any, callback: (result: any) => void): Promise<void>;
    stopLEScan(): Promise<void>;
    connect(deviceId: string, disconnectCallback: () => void): Promise<void>;
    disconnect(deviceId: string): Promise<void>;
    startNotifications(deviceId: string, service: string, characteristic: string, callback: (value: DataView) => void): Promise<void>;
    write(deviceId: string, service: string, characteristic: string, value: DataView, options?: TimeoutOptions): Promise<void>;
}

export class IQConnectBleClient implements IBleClient {
    async initialize(): Promise<void> {
        return await BleClient.initialize({ androidNeverForLocation: true });
    }
    async requestDevice(options: any): Promise<any> {
        return await BleClient.requestDevice(options);
    }
    async requestLEScan(options: any, callback: (result: any) => void): Promise<void> {
        return await BleClient.requestLEScan(options, callback);
    }
    async stopLEScan(): Promise<void> {
        return await BleClient.stopLEScan();
    }
    async connect(deviceId: string, disconnectCallback: () => void): Promise<void> {
        return await BleClient.connect(deviceId, disconnectCallback);
    }
    async disconnect(deviceId: string): Promise<void> {
        return await BleClient.disconnect(deviceId);
    }
    async startNotifications(deviceId: string, service: string, characteristic: string, callback: (value: DataView) => void): Promise<void> {
        return await BleClient.startNotifications(deviceId, service, characteristic, callback);
    }
    async write(deviceId: string, service: string, characteristic: string, value: DataView, options?: TimeoutOptions): Promise<void> {
        return await BleClient.write(deviceId, service, characteristic, value, options);
    }
}